/**
 * Holi social posts — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_shivratri_holi`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const holiSocialPostsPack: ToilePack = {
    slug: 'holi-social-posts',
    category: 'faith',
    name: 'Holi social posts',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'greeting', label: 'Happy Holi', subject: 'a square post with "Happy Holi" lettered in the middle of a burst of pink, yellow, green and blue colour powder'},
        {key: 'shop', label: 'For a shop', subject: 'a square post with "Happy Holi from all of us" lettered under a row of colour pots, with an empty space at the top for a shop\'s logo'},
        {key: 'radha', label: 'Radha Krishna', subject: 'a square post with the silhouettes of Radha and Krishna under a kadamba tree in a cloud of colour, "Happy Holi" lettered beneath'},
    ],
    styles: [
        {key: 'burst', label: 'Colour burst', style: 'a flat graphic design with bold colour powder bursts and soft dusty edges', palette: 'pink, yellow, green, blue and orange on white', framing: 'The greeting is centred and readable, the colour filling the whole square.'},
        {key: 'paper', label: 'Paper cut', style: 'layered paper-cut shapes with soft drop shadows between the layers', palette: 'magenta, saffron, turquoise and leaf green', framing: 'The greeting sits in the middle of the square with an even margin of colour round it.'},
        {key: 'night', label: 'Dark glow', style: 'glowing colour clouds and sparkle on a deep ground, smooth gradient-free fills for the lettering', palette: 'pink, yellow, cyan and green on deep indigo', framing: 'The greeting is centred in bright letters on the dark square.'},
    ],
    directions: ['in Hindi', 'for a school', 'white ground'],
    directionHint: 'try: in Hindi',
    seo: {
        title: 'Holi social posts: happy Holi, shop, Radha Krishna',
        metaDescription: 'Nine square Holi greetings for Instagram, a WhatsApp status or a shop page, each with a short greeting over colour, in three styles.',
        h1: 'Holi social posts: happy Holi, a shop greeting, Radha and Krishna',
        tagline: 'Nine square posts for the morning of the festival, three greetings in three styles each.',
        intro: 'Square Holi greetings for an Instagram post, a WhatsApp status or a shop page, for the morning of the festival. Each carries a short greeting in clear letters over Holi colour: Happy Holi over a burst of powder, a shop greeting under a row of colour pots with space for a logo, or Happy Holi beneath Radha and Krishna in a cloud of colour. Type a different greeting, such as one in Hindi, and the styles carry it.',
        useCases: [
            'A personal post on the morning of Holi',
            'A greeting for a shop or café page',
            'A WhatsApp status for family and friends',
            'A greeting for a school or a community group page',
        ],
        faq: [
            {q: 'What shape are the posts?', a: 'Each post is square, the shape used for an Instagram post.'},
            {q: "Can I add a shop's logo?", a: 'The shop greeting leaves an empty space at the top where a logo can be placed afterwards.'},
            {q: 'What is the difference between the three styles?', a: 'Colour burst is bold powder bursts on white, paper cut is layered shapes with soft shadows, and dark glow is bright lettering on deep indigo.'},
        ],
    },
}
